import useTracker from '@hooks/useTracker';
import { CLICK_STOCK_CATEGORY } from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventClickStockCategory = (props) => {
    trackEvent(CLICK_STOCK_CATEGORY, props);
  };

  return {
    eventClickStockCategory,
  };
};

export default useEventTracker;
